import { executeRequest, Request, Response } from '@jfs/network'
import { DUMMY_MOBILE } from '../data/models/Session'
import { RootStore } from './../data/store'
import { AESEncrypt, generateRandomString, isEmpty, RSAEncrypt } from './../util/util'
import { APIEndPoints } from './APIEndpoints'
import { BASE_URL, usrSessionRefreshConfig } from './config'

const responseParser = (response: any) => {
  return {
    jfsUserId: response?.jfsUserId,
    refreshToken: response?.session?.refreshToken?.tokenValue,
    identifierToken: response?.session?.identifierToken,
    accessToken: response?.session?.accessToken?.tokenValue,
    accessTokenExpiresIn: response?.session?.accessToken?.expiresIn,
    refreshTokenExpiresIn: response?.session?.refreshToken?.expiresIn,
  }
}

export const extendUserSession = (
  mobileNumber: string,
  accessToken: string,
  refreshToken: string,
  isAgentPortal?: boolean,
) => {
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, accessToken)
  let refToken = AESEncrypt(randomEncryptionKey, refreshToken)
  const mob = mobileNumber.slice(0, 1) === '+' ? mobileNumber.slice(3) : mobileNumber

  const APP_ACCESS_TOKEN = isAgentPortal
    ? RootStore.agentQrSession.appAccessToken
    : RootStore.user.session.appAccessToken
  const APP_ID_TOKEN = isAgentPortal ? RootStore.agentQrSession.appIdToken : RootStore.user.session.appIdToken
  const isEmailLogin = RootStore?.user?.session?.isEmailLogin

  const request: Request<{}> = {
    apiPath: `${BASE_URL}${APIEndPoints.userSessionExtend}`,
    method: 'POST',
    headers: usrSessionRefreshConfig(APP_ACCESS_TOKEN, APP_ID_TOKEN).headers,
    body: {
      user: {
        emailAddress: isEmailLogin ? RootStore?.user?.session?.emailId : undefined,
        mobile: {
          mobileNumber: isEmailLogin ? DUMMY_MOBILE : mob,
          countryCode: '91',
        },
      },
      authenticateList: [
        {
          mode: 14,
          accessToken: token,
          refreshToken: refToken,
        },
      ],
      scope: 'SESSION',
      purpose: 1,
      secure: {
        encryptionKey: encryptedKey,
      },
    },
  }
  return request
}

export const HeaderTransformer = async (response: Response, originalRequest?: Request<any>) => {
  const { data } = response
  if (
    data?.status === 'SUCCESS' &&
    !isEmpty(data?.session?.accessToken?.tokenValue) &&
    !isEmpty(data?.session?.refreshToken?.tokenValue) &&
    !isEmpty(data?.session?.identifierToken) &&
    !isEmpty(data?.jfsUserId)
  ) {
    const sessionData = responseParser(data)

    if (
      sessionData &&
      originalRequest &&
      sessionData.accessToken &&
      sessionData.identifierToken &&
      originalRequest.headers
    ) {
      originalRequest.headers = {
        ...originalRequest.headers,
        'x-user-access-token': sessionData.accessToken,
        'x-trace-id': generateRandomString(16),
        'x-userid-token': sessionData.identifierToken,
      }
    }
    await RootStore.user.session.updateUserSessionData(
      sessionData.refreshToken,
      sessionData.identifierToken,
      sessionData.accessToken,
      sessionData.accessTokenExpiresIn,
      sessionData.refreshTokenExpiresIn,
      sessionData?.jfsUserId ?? '',
    )
  } else {
    await RootStore.user.session.updateAppSessionData('', '', -1, -1, '')
    await RootStore.user.session.updateUserSessionData('', '', '', -1, -1, '')
    RootStore.settings.metaData.updateSelectedMercName('')
    RootStore.user.updateSelectedMercMid('')
  }
}

export const HeaderTransformerAgentPortal = (response: Response, originalRequest?: Request<any>) => {
  const { data } = response
  if (
    data?.status === 'SUCCESS' &&
    !isEmpty(data?.session?.accessToken?.tokenValue) &&
    !isEmpty(data?.session?.refreshToken?.tokenValue) &&
    !isEmpty(data?.session?.identifierToken) &&
    !isEmpty(data?.jfsUserId)
  ) {
    const sessionData = responseParser(data)
    RootStore.agentQrSession.updateUserTokens(data)

    if (
      sessionData &&
      originalRequest &&
      sessionData.accessToken &&
      sessionData.identifierToken &&
      originalRequest.headers
    ) {
      originalRequest.headers = {
        ...originalRequest.headers,
        'x-user-access-token': sessionData.accessToken,
        'x-trace-id': generateRandomString(16),
        'x-userid-token': sessionData.identifierToken,
      }
    }
  } else {
    RootStore.agentQrSession.resetAccessToken()
    window?.localStorage.removeItem('csoSessData')
    window.localStorage.removeItem('csoUserMobileNumber')
  }
}

export const extendUserSessionAPI = () => {
  const userMobileNo = RootStore?.settings?.metaData?.mobileNumber
  const sessUsrAccessToken = RootStore?.user?.session?.userAccessToken
  const sessUsrRefreshToken = RootStore?.user?.session?.userRefreshToken
  const request = extendUserSession(userMobileNo, sessUsrAccessToken, sessUsrRefreshToken)
  return executeRequest(request).then((response) => {
    return HeaderTransformer(response)
  })
}
